import axios from "axios";
import { call, cancelled, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as SuggestActions } from "../ducks/suggest";

let cancelSuggestionRequest = null;

export function* getSuggestions() {
  const source = axios.CancelToken.source();

  if (cancelSuggestionRequest) {
    cancelSuggestionRequest("Nova busca de sugestão iniciada");
  }

  cancelSuggestionRequest = source.cancel;

  try {
    const { searchTerm } = yield select(state => state.search);
    const { offset, limit } = yield select(state => state.suggest);
    const { data: store } = yield select(state => state.store);

    if (!searchTerm || searchTerm.length <= 2) {
      yield put(SuggestActions.clearSuggestions());
      return;
    }

    const { data } = yield call(
      api.post,
      `/products/suggestions?_offset=${offset}&_limit=${limit}`,
      {
        termo: searchTerm,
        store: store ? store.uuid : undefined
      },
      {
        cancelToken: source.token
      }
    );

    yield put(SuggestActions.getSuggestionsSuccess(data));
  } catch (err) {
    if (!axios.isCancel(err)) {
      yield put(SuggestActions.clearSuggestions());
    }
  } finally {
    if (yield cancelled()) {
      source.cancel("Busca de sugestão cancelada");
    }

    if (cancelSuggestionRequest === source.cancel) {
      cancelSuggestionRequest = null;
    }
  }
}

export function* clearSuggestions() {
  yield put(SuggestActions.clearSuggestions());
}
